import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Layout as AntLayout, Menu, Button, Avatar, Dropdown, Space, Typography } from 'antd';
import {
  DashboardOutlined,
  GlobalOutlined,
  FileTextOutlined,
  FormOutlined,
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = AntLayout;
const { Text } = Typography;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/dashboard">控制面板</Link>,
    },
    {
      key: '/websites',
      icon: <GlobalOutlined />,
      label: <Link to="/websites">网站管理</Link>,
    },
    {
      key: '/contents',
      icon: <FileTextOutlined />,
      label: <Link to="/contents">内容管理</Link>,
    },
    {
      key: '/forms',
      icon: <FormOutlined />,
      label: <Link to="/forms">表单管理</Link>,
    },
    {
      key: 'user',
      icon: <UserOutlined />,
      label: '用户管理',
      hidden: user?.role !== 'admin',
      children: [
        {
          key: '/users',
          label: <Link to="/users">所有用户</Link>,
        },
        {
          key: '/users/new',
          label: <Link to="/users/new">添加用户</Link>,
        },
      ],
    },
  ];

  const visibleItems = items.filter(item => !item.hidden);

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: () => {
        // 导航到个人资料页面
      },
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '设置',
      onClick: () => {
        // 导航到设置页面
      },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        logout();
        navigate('/login');
      },
    },
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} width={240}>
        <div style={{ height: 64, padding: 16, display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'flex-start' }}>
          {!collapsed && <h1 style={{ color: '#fff', margin: 0 }}>R7HK Admin</h1>}
          {collapsed && <GlobalOutlined style={{ color: '#fff', fontSize: 24 }} />}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          items={visibleItems}
        />
      </Sider>
      <AntLayout>
        <Header style={{ padding: 0, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '16px', width: 64, height: 64 }}
          />
          <Space style={{ marginRight: 24 }}>
            <Dropdown menu={{ items: userMenuItems }}>
              <Space style={{ cursor: 'pointer' }}>
                <Avatar icon={<UserOutlined />} />
                {user && <Text>{user.name}</Text>}
              </Space>
            </Dropdown>
          </Space>
        </Header>
        <Content style={{ margin: '24px 16px' }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout; 